import { render, staticRenderFns } from "./remind-record-form.vue?vue&type=template&id=c09802bc&scoped=true"
import script from "./remind-record-form.vue?vue&type=script&lang=js"
export * from "./remind-record-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09802bc",
  null
  
)

export default component.exports